module.exports = __webpack_public_path__ + "static/AlmondBar-50be6d5efdbc5896cd262c6859d10be9.jpg";